import { render } from "./modalmessage.vue?vue&type=template&id=21714072"
import script from "./modalmessage.vue?vue&type=script&lang=js"
export * from "./modalmessage.vue?vue&type=script&lang=js"

import "./modalmessage.vue?vue&type=style&index=0&id=21714072&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__